"use client";

// Right-pointing triangle used as the disclosure marker on `:::details` boxes and
// SourceBox. Replaces the literal ▶ (U+25B6) character, which iOS/Android substitute
// with a colorful emoji glyph — an inline SVG renders identically on every device.
// Sized in `em` so it inherits the surrounding font-size, and fills with currentColor.
export default function TriangleMarker({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="0.7em"
      height="0.7em"
      viewBox="0 0 10 10"
      fill="currentColor"
      aria-hidden="true"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M2 1 L9 5 L2 9 Z" />
    </svg>
  );
}
